export function StaticImplements<T>() {
  return (constructor: T) => { /* VOID */ }
}
